export default {"src":"/_next/static/media/launch.fd7396f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};